import $ from 'jquery';
import {} from 'select2';

function forms() {
	let $form 	= $('.gform_wrapper form');
	// Bail if no form
	if ( !$form ) return;

	// Disable autocomplete for datepickers
	let $datepicker = $form.find('input[type=text].datepicker');
			$datepicker.attr('autocomplete', 'off');

	inputFocus();
	addSelect2();

	// Run inputFocus after next page is loaded in multipage form
	$(document).on('gform_page_loaded', function(event, form_id, current_page){
		inputFocus();
		addSelect2();
	});

	// Input label focus effect
	function inputFocus() {
		let $form 	= $('.gform_wrapper form'),
			$input 	= $form.find('input:not(input[type=submit]), textarea'),
			$number = $form.find('.ginput_container_number');

		$input.focusin(function() {
			$(this).parent().siblings('label').addClass('is-active');
		}).focusout(function(){
			if( !$(this).val() ) {
				$(this).parent().siblings('label').removeClass('is-active');
			}
		});

		// Check if input has value, if it has value float the label
		$input.each(function() {
			if( $(this).val() ) {
				$(this).parent().siblings('label').addClass('is-active');
			}
		});
	}

	// Add select2 to forms
	function addSelect2() {
		let $form 	= $('.gform_wrapper form'),
				$select = $form.find('select');

		$select.each(function() {
			let $parent = $(this).parent();

			$(this).select2({
				dropdownParent: $parent,
			});
		});

		// Auto select on search field
		$(document).on('select2:open', () => {
			document.querySelector('.select2-search__field').focus();
		});
	}
}

export { forms };